import { FC } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CreateSecret } from './components/CreateSecret';
import { ViewSecret } from './components/ViewSecret';
import { AuthCallback } from './components/AuthCallback';
import { TermsOfUse } from './components/TermsOfUse';
import { ReactComponent as Logo } from './capintel-logo.svg';
import styled from 'styled-components';
import { useAuth } from './contexts/AuthContext';

const Wrap = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: Inter, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  font-family: Inter, Arial, sans-serif;
  flex: 1;
  padding: 0 2rem;
  box-sizing: border-box;
  display: flex;
`;

const Header = styled.div`
  padding: 0 2rem;
  max-width: 800px;
  width: 100%;
  background-color: #2937B5;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
`;

const HeaderWrap = styled.div`
  width: 100%;
  background-color: #2937B5;
  display: flex;
  justify-content: center;
`;

const Footer = styled.div`
  width: 100%;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  box-sizing: border-box;
  
  p {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
  }

  a {
    color: #2937B5;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const App: FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <Wrap style={{ display: isAuthenticated ? "flex" : "none" }}>
        <HeaderWrap>
          <Header>
            <a href="/">
              <Logo className="logo" />
            </a>
            <a className="help" href="https://capintel.atlassian.net/servicedesk/customer/portal/2/group/6/create/24">
              Help
              <span className="decoration"></span>
            </a>
          </Header>
        </HeaderWrap>
        <Container>
          <BrowserRouter>
            <Routes>
              <Route path="/callback" element={<AuthCallback />} />
              <Route path="/" element={<CreateSecret />} />
              <Route path="/secrets/:secretId" element={<ViewSecret />} />
              <Route path="/terms" element={<TermsOfUse />} />
            </Routes>
          </BrowserRouter>
        </Container>
        <Footer>
          <p>
            © {new Date().getFullYear()} CapIntel
            <span>•</span>
            <a href="/terms">Terms of Use</a>
          </p>
        </Footer>
      </Wrap>
    </>
  );
};

export default App;
